import React, { Component } from "react";
import styled from "styled-components";
import { Menu, MenuItem } from "@material-ui/core";

import {
    ViewModule as ViewModuleIcon,
    Edit as EditIcon,
    Share as ShareIcon,
} from "@material-ui/icons";
import { t } from "js/i18n";

const StyledMenu = styled(Menu)`
  
  & > .MuiPaper-root {
    & > .MuiList-padding {
        padding-top: 0;
        padding-bottom: 0;
    }
  }

  .MuiMenuItem-root {
    font-family: "Source Sans Pro";
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    fill: #333333;

    .MuiIcon-root,
    .MuiSvgIcon-root {
      font-size: 24px;
      margin-right: 15px;
      color: #333333;
      fill: #333333;
    }

  }
`;

class MobilePresentationActionsMenu extends Component {
    closeAfterAction = action => {
        const {
            onClose,
            registerUserInteraction,
        } = this.props;

        if (action) {
            action();
            onClose();
            registerUserInteraction?.();
        }
    }

    render() {
        const {
            open,
            onClose,
            anchorEl,
            anchorPosition,
            showThumbnailsPane,
            onSharePresentation,
            onEditOnDesktop,
            canEditPresentation,
        } = this.props;

        return (
            <StyledMenu
                open={open}
                anchorReference={anchorPosition ? "anchorPosition" : "anchorEl"}
                anchorPosition={anchorPosition}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                disableEnforceFocus
                style={{ zIndex: 999999 }}
                onClose={onClose}
                onClick={event => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
            >
                <MenuItem
                    key="slide-grid"
                    onClick={() => this.closeAfterAction(showThumbnailsPane)}
                >
                    <ViewModuleIcon />
                    {t("Grid View")}
                </MenuItem>

                {canEditPresentation && <MenuItem
                    key="edit-presentation"
                    onClick={() => this.closeAfterAction(onEditOnDesktop)}
                >
                    <EditIcon />
                    {t("Edit")}
                </MenuItem>}

                {canEditPresentation && <MenuItem
                    key="share-presentation"
                    onClick={() => this.closeAfterAction(onSharePresentation) }
                >
                    <ShareIcon />
                    {t("Share")}
                </MenuItem>}

            </StyledMenu>
        );
    }
}

export default MobilePresentationActionsMenu;
